import CardImageSimple from "./CardImageSimple";
import CardImageText from "./CardImageText";
import CardText from "./CardText";
import CardVideo from "./CardVideo";
import { GalleryCardEntry } from "./CardsGalleriesCarousel";

interface CardDataProp {
  entry: GalleryCardEntry;
}

export default function CardGallery({ entry }: CardDataProp) {
  return (
    <>
      {entry.type == "galleryCardImageVideo" && entry.image && <CardImageSimple image={entry.image} aspectRatio={entry.aspectRatio} />}
      {entry.type == "galleryCardImageVideo" && entry.video && entry.videoBackupImage && (
        <CardVideo posterSrc={entry.videoBackupImage.url} videoSrc={entry.video.url} ratio={entry.aspectRatio} />
      )}
      {entry.type == "galleryCardText" && entry.title && (
        <CardText
          titleText={entry.title}
          descriptionText={entry.description}
          backgroundColor={entry.backgroundColor}
          textColor={entry.textColor}
          ratio={entry.aspectRatio}
        />
      )}
      {entry.type == "galleryCardImageText" && entry.image && entry.title && entry.textAlignment && (
        <CardImageText
          src={entry.image.url}
          altText={entry.image.description || entry.image.title}
          position={entry.textAlignment}
          titleText={entry.title}
          descriptionText={entry.description}
          textColor={entry.textColor}
          ratio={entry.aspectRatio}
          gradient={entry.gradient}
          width={entry.image.width}
          height={entry.image.height}
          titleColor={entry.titleColor}
        />
      )}
    </>
  );
}
